import {
  type Configuration,
  LogLevel,
  type RedirectRequest,
} from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

if (!tenantId || !clientId) {
  // Falha cedo: sem isso o login não funciona.
  // eslint-disable-next-line no-console
  console.error(
    "[msal] VITE_ENTRA_TENANT_ID / VITE_ENTRA_CLIENT_ID ausentes. Veja .env.example."
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    // Single-tenant: só usuários do tenant JusCapital
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage: limpa ao fechar aba (mais seguro que localStorage para dados sensíveis)
    cacheLocation: "sessionStorage",
    // true: necessário pro Safari/iOS (ITP) não quebrar o fluxo de redirect de auth
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) {
          // eslint-disable-next-line no-console
          console.error("[msal]", message);
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes para login (ID token + perfil)
export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

// Scope para chamar nossa API. Configurado no App Registration como "Expose an API".
// Por padrão, usamos o próprio clientId como audience (api://<clientId>/access_as_user).
export const apiScope = `api://${clientId ?? ""}/access_as_user`;

export const apiTokenRequest = {
  scopes: [apiScope],
};
